import * as Dialog from '@radix-ui/react-dialog';
import { ModalLayout } from './modal-layout';

export const ErrorPopup = ({ onClose }: { onClose?: () => void }) => {
    return (
        <ModalLayout title="안내" wrapClassNm="box-width2" contClassNm="cont-pd1">
            <div className="noti-box">
                <div className="noti-box__txt2">잠시 후 다시 시도해 주세요.</div>
                <div className="noti-box__txt3 con-mt1">
                    현재 시스템에서 일시적인 문제가 발생했습니다.
                    <br />
                    문제가 해결되는대로 서비스를 정상화할 예정이니,
                    <br />
                    조금만 기다려 주시면 감사하겠습니다. 불편을 드려 죄송합니다.
                </div>

                <div className="noti-box__contact con-mt2">
                    <div className="tel tel2">
                        비바샘 고객센터 : <b>1544-7714</b>
                    </div>
                </div>
            </div>

            <div className="btn-wrap btn-width1 con-mt3">
                <Dialog.Close asChild>
                    <button type="button" className="btn btn-default blue" onClick={onClose}>
                        확인
                    </button>
                </Dialog.Close>
            </div>
        </ModalLayout>
    );
};
